import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },

  text: {
    textAlign: 'center'
  },

  name: {
    marginTop: '1rem',
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}))

export default useStyles
